// V2 is enabled per environment so production can keep the legacy integration
// until its token endpoint and embed have been deployed.
export const isSeekyV2Enabled = process.env.REACT_APP_SEEKY_V2_ENABLED === 'true';
export const chatbotOrigin = (isSeekyV2Enabled
  ? process.env.REACT_APP_SEEKY_ORIGIN
  : process.env.REACT_APP_CHATBOT_ORIGIN)?.trim();
export const chatbotUrl = isSeekyV2Enabled
  ? process.env.REACT_APP_SEEKY_URL?.trim()
  : chatbotOrigin ? `${chatbotOrigin}/embed` : undefined;
export const seekyTokenUrl = process.env.REACT_APP_SEEKY_TOKEN_URL?.trim();

export const isChatbotMessage = (event, frame) =>
  Boolean(chatbotOrigin && frame?.contentWindow &&
    event.origin === chatbotOrigin && event.source === frame.contentWindow &&
    event.data && typeof event.data === 'object');
